var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState } from "react";
import { Card, Spinner, Table } from "react-bootstrap";
import "../../stylesheets/components/Generic/SalesProcessTable.scss";
import Loader from "@frameworks/shared-library/components/Loader";
import ReportValue from "../../../shared-library/components/commonTableVal";
import ErrorNotification, { ErrorDisplayType } from "./ErrorNotification";
import ToggleSwitch from "@frameworks/web/components/generic/SwitchButton/Switch";
import summarize from "@domains/utils/summarize";
import GenericTooltip from "../../../shared-library/components/GenericTooltip";
import { getSortedData } from "@domains/utils/sort";
export var ERoleID;
(function (ERoleID) {
    ERoleID["Client"] = "1";
    ERoleID["Partner"] = "2";
    ERoleID["ClientANDPartner"] = "3";
})(ERoleID || (ERoleID = {}));
var SaleProcessTable = function (props) {
    var _a, _b, _c, _d, _e;
    var _f = __read(React.useState([]), 2), showData = _f[0], setShowData = _f[1];
    var _g = __read(React.useState([]), 2), rowData = _g[0], setRowData = _g[1];
    var _h = __read(useState(props.tbodyData), 2), tableData = _h[0], setTableData = _h[1];
    var _j = __read(useState(false), 2), sortingType = _j[0], setSortingType = _j[1];
    var _k = __read(useState({
        key: "product",
        dataType: "string",
    }), 2), sortType = _k[0], setSortType = _k[1];
    var applySortingAccordingKey = function (key, dataType, sortType, data) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            setSortingType(sortType);
            setSortType({
                key: key,
                dataType: dataType,
            });
            result = getSortedData(data ? data : tableData, sortType, key, dataType);
            setTableData(result);
            return [2 /*return*/];
        });
    }); };
    return (React.createElement(Card, { className: "sales-process-table border-0 ".concat(props.parentClass ? props.parentClass : "") },
        React.createElement(Card.Header, { className: "no_bg sales-header" },
            React.createElement("div", { className: "d-flex justify-content-between" },
                props.headComp,
                React.createElement("div", { className: "d-flex align-items-center p-0" },
                    props.summarize && (React.createElement("div", { className: "summarized-block d-flex align-items-center" },
                        React.createElement(ToggleSwitch, { id: "summarize", name: "summarize", checked: props.toggleCheck, onChange: props.setToggleCheck, small: true, className: "sales-toggle" }),
                        React.createElement("span", { className: "DMSanN_14_400 txt_blackOne1 summaries-val-block ps-2" }, "Summarize Values"))),
                    (props === null || props === void 0 ? void 0 : props.downloadloader) ? (React.createElement("div", { className: "spinner-box sale ps-2" },
                        React.createElement(Spinner, { animation: "border", variant: "primary", size: "sm" }))) : (React.createElement("i", { className: "edel-icon-download-page hand_cursor h5 m-0", onClick: function () {
                            props.downloadFunction();
                        } },
                        React.createElement("span", { className: "path1" }),
                        React.createElement("span", { className: "path2" }),
                        React.createElement("span", { className: "path3" })))))),
        (props === null || props === void 0 ? void 0 : props.Loader) && React.createElement(Loader, null),
        ((_a = props === null || props === void 0 ? void 0 : props.errorData) === null || _a === void 0 ? void 0 : _a.isOpen) && (React.createElement(Card.Body, { className: "card-error" },
            React.createElement(ErrorNotification, { error: (_b = props === null || props === void 0 ? void 0 : props.errorData) === null || _b === void 0 ? void 0 : _b.error, isOpen: (_c = props === null || props === void 0 ? void 0 : props.errorData) === null || _c === void 0 ? void 0 : _c.isOpen, displayType: ErrorDisplayType.INSECTION }))),
        !((_d = props === null || props === void 0 ? void 0 : props.errorData) === null || _d === void 0 ? void 0 : _d.isOpen) && (React.createElement(Card.Body, { className: "p-0 sale-process-body" },
            React.createElement(Table, { responsive: true, className: "sales-table m-0 ".concat((props === null || props === void 0 ? void 0 : props.showDataFor) == ERoleID.Partner && "sales-table-partner") },
                React.createElement("thead", { className: "bg_aqua_white" },
                    props.isNRSummary && (React.createElement(React.Fragment, null, (props === null || props === void 0 ? void 0 : props.showDataFor) == ERoleID.ClientANDPartner ? (React.createElement("tr", { className: "revenue-main-header" },
                        React.createElement("th", { colSpan: 1 }, "Product"),
                        React.createElement("th", { colSpan: 1 }, "Total"),
                        React.createElement("th", { colSpan: 3 }, "Partner Pipeline"),
                        React.createElement("th", { colSpan: 7 }, "Client Pipeline"))) : (React.createElement("tr", { className: "revenue-main-header" },
                        React.createElement("th", { colSpan: 1 }, "Product"),
                        React.createElement("th", { colSpan: 1 },
                            React.createElement("span", null, " Total")),
                        (props === null || props === void 0 ? void 0 : props.showDataFor) == ERoleID.Client ? (React.createElement("th", { colSpan: 10 }, "Client Pipeline")) : (React.createElement("th", { colSpan: 10 }, "Partner Pipeline")))))),
                    React.createElement("tr", { className: props.isNRSummary
                            ? (props === null || props === void 0 ? void 0 : props.showDataFor) != ERoleID.ClientANDPartner
                                ? "revenue-sub-header-rm"
                                : "revenue-sub-header"
                            : "" }, props.columnsList &&
                        props.columnsList.map(function (column, idx) {
                            return (React.createElement("th", { key: idx, className: "DMSan_14_500 txt_primaryGrey" },
                                React.createElement("span", null,
                                    column.tooltipText ? (React.createElement(GenericTooltip, { placement: "top", toolTipText: column.tooltipText, triggerType: "hover", toolTipClassName: "profile-tooltips", noButton: true, button: column.name })) : (column.name),
                                    props.isShowSorting && (React.createElement("i", { className: "edel-icon-caret-down" })))));
                        }))),
                React.createElement("tbody", { className: "".concat(props.isNRSummary && "revenue-table-body") }, props.tbodyData &&
                    ((_e = props.tbodyData) === null || _e === void 0 ? void 0 : _e.length) > 0 &&
                    props.tbodyData.map(function (row, trId) {
                        if (row["data"]) {
                            return (React.createElement(React.Fragment, null,
                                React.createElement("tr", { key: trId, className: "".concat(props.isNRSummary
                                        ? (props === null || props === void 0 ? void 0 : props.showDataFor) != ERoleID.ClientANDPartner
                                            ? "revenue-table-body-row-rm"
                                            : "revenue-table-body-row"
                                        : "", " ").concat(showData[trId] ? "opened-row" : "") }, props.columnsList &&
                                    props.columnsList.map(function (column, id) {
                                        if (id === 0)
                                            return (React.createElement("td", { className: "extra-data border-0 hand_cursor", key: id, onClick: function () {
                                                    var temp = __spreadArray([], __read(showData), false);
                                                    temp[trId] = !temp[trId];
                                                    setShowData(temp);
                                                } },
                                                React.createElement("div", { className: "d-flex align-items-center gap-2 extra-data-icon-wrapper txt_blackOne1" },
                                                    React.createElement("i", { className: "".concat(showData[trId]
                                                            ? "edel-icon-minus"
                                                            : "edel-icon-plus", " txt-midnight-blue ") }),
                                                    column.tdCustomFunction
                                                        ? column.tdCustomFunction(row["".concat(column.key)], row, column.key, false, trId, props.toggleCheck, row["".concat(column === null || column === void 0 ? void 0 : column.key2)], false, column === null || column === void 0 ? void 0 : column.key, column === null || column === void 0 ? void 0 : column.key2)
                                                        : row["".concat(column.key)])));
                                        else {
                                            return (React.createElement("td", { key: id }, column.tdCustomFunction
                                                ? column.tdCustomFunction(row["".concat(column.key)], row, column.key, column.notClickable !== null &&
                                                    column.notClickable !== undefined
                                                    ? column.notClickable
                                                    : (props === null || props === void 0 ? void 0 : props.allowedClick)
                                                        ? props === null || props === void 0 ? void 0 : props.allowedClick
                                                        : false, trId, props.toggleCheck, row["".concat(column === null || column === void 0 ? void 0 : column.key2)], false, column === null || column === void 0 ? void 0 : column.key, column === null || column === void 0 ? void 0 : column.key2)
                                                : row["".concat(column.key)]));
                                        }
                                    })),
                                showData[trId] &&
                                    row["data"].map(function (extraData, idx) {
                                        var _a;
                                        return (React.createElement(React.Fragment, null,
                                            React.createElement("tr", { key: idx, className: "no-border ".concat(props.isNRSummary
                                                    ? (props === null || props === void 0 ? void 0 : props.showDataFor) !=
                                                        ERoleID.ClientANDPartner
                                                        ? "revenue-table-body-row-rm"
                                                        : "revenue-table-body-row"
                                                    : "", " ").concat(rowData[idx + 10 * trId] && "opened-row") }, props.columnsList &&
                                                props.columnsList.map(function (column, id) {
                                                    return (React.createElement("td", { className: "".concat(id === 0 && "hand_cursor"), key: id, onClick: function () {
                                                            var temp = __spreadArray([], __read(rowData), false);
                                                            temp[idx + 10 * trId] =
                                                                !temp[idx + 10 * trId];
                                                            setRowData(temp);
                                                        } },
                                                        id === 0 && extraData.data && (React.createElement("i", { className: "no-border-icon txt-midnight-blue ".concat(rowData[idx + 10 * trId]
                                                                ? "edel-icon-minus"
                                                                : "edel-icon-plus") })),
                                                        column.tdCustomFunction
                                                            ? column.tdCustomFunction(extraData["".concat(column.key)], row, column.key, column.notClickable !== null &&
                                                                column.notClickable !==
                                                                    undefined
                                                                ? column.notClickable
                                                                : true, idx, props.toggleCheck, extraData["".concat(column === null || column === void 0 ? void 0 : column.key2)], true, column === null || column === void 0 ? void 0 : column.key, column === null || column === void 0 ? void 0 : column.key2)
                                                            : extraData["".concat(column.key)]));
                                                })),
                                            ((_a = extraData === null || extraData === void 0 ? void 0 : extraData.data) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                                                rowData[idx + 10 * trId] &&
                                                extraData.data.map(function (subColumn, extraDataId) {
                                                    return (React.createElement("tr", { key: extraDataId, className: "no-border " }, props.columnsList &&
                                                        props.columnsList.map(function (column, colId) {
                                                            var _a;
                                                            return (React.createElement("td", { key: colId },
                                                                React.createElement("span", { className: colId === 0 &&
                                                                        "sub-column" }, column.tdCustomFunction
                                                                    ? column.tdCustomFunction(subColumn["".concat(column.key)], row, column.key, column.notClickable !==
                                                                        null &&
                                                                        column.notClickable !==
                                                                            undefined
                                                                        ? column.notClickable
                                                                        : true, idx, props.toggleCheck, subColumn["".concat(column === null || column === void 0 ? void 0 : column.key2)], true, column === null || column === void 0 ? void 0 : column.key, column === null || column === void 0 ? void 0 : column.key2, extraDataId, (_a = row[idx]) === null || _a === void 0 ? void 0 : _a.data[extraDataId])
                                                                    : subColumn[column.key])));
                                                        })));
                                                })));
                                    })));
                        }
                        return (React.createElement("tr", { key: trId }, props.columnsList &&
                            props.columnsList.map(function (column, id) {
                                return (React.createElement("td", { key: id }, column.tdCustomFunction
                                    ? column.tdCustomFunction(row["".concat(column.key)], row, column.key, false, trId, props.toggleCheck, row["".concat(column === null || column === void 0 ? void 0 : column.key2)])
                                    : row["".concat(column.key)]));
                            })));
                    })),
                React.createElement("tfoot", { className: props.tfootColored ? "bg-banana-mania" : "" },
                    React.createElement("tr", { className: props.isNRSummary
                            ? (props === null || props === void 0 ? void 0 : props.showDataFor) != ERoleID.ClientANDPartner
                                ? "revenue-footer-rm"
                                : "revenue-footer"
                            : "" },
                        React.createElement("td", { className: "" }, "Total"),
                        (props === null || props === void 0 ? void 0 : props.showClientCount) && React.createElement(React.Fragment, null, props === null || props === void 0 ? void 0 : props.totalDataUI()),
                        !(props === null || props === void 0 ? void 0 : props.showClientCount) &&
                            (props === null || props === void 0 ? void 0 : props.totolData) &&
                            (props === null || props === void 0 ? void 0 : props.totolData.length) > 0 &&
                            props.totolData.map(function (record, id) {
                                return (React.createElement("td", { key: id, className: "txt-midnight-blue" },
                                    React.createElement(ReportValue, { val: props.toggleCheck ? summarize(record) : record, stream: false, onlyval: false, withoutDigit: true, showZero: false, showSummarize: props.toggleCheck })));
                            })))))))
    // <Card
    //   className={`sales-process-table border-0 ${
    //     props.parentClass ? props.parentClass : ""
    //   }`}
    // >
    //   {/* <Card.Header className="no_bg sales-header">
    //     <div className="d-flex justify-content-between">
    //       {props.headComp}
    //       <div className="d-flex align-items-center p-0">
    //         {props.summarize && (
    //           <div className="summarized-block d-flex align-items-center">
    //             <ToggleSwitch
    //               id={"summarize"}
    //               name={"summarize"}
    //               checked={props.toggleCheck}
    //               onChange={props.setToggleCheck}
    //               small
    //               className="sales-toggle"
    //             />
    //             <span className="DMSanN_14_400 txt_blackOne1 summaries-val-block ps-2">
    //               Summarize Values
    //             </span>
    //           </div>
    //         )}
    //         {props?.downloadloader ? (
    //           <div className="spinner-box sale ps-2">
    //             <Spinner animation="border" variant="primary" size="sm" />
    //           </div>
    //         ) : (
    //           <img
    //             src={FolderImg}
    //             alt=""
    //             className="hand_cursor ps-2"
    //             onClick={() => {
    //               props.downloadFunction();
    //             }}
    //           />
    //         )}
    //       </div>
    //     </div>
    //   </Card.Header> */}
    //   {props?.Loader && <Loader />}
    //   {props?.errorData?.isOpen && (
    //     <Card.Body className="card-error">
    //       <ErrorNotification
    //         error={props?.errorData?.error}
    //         isOpen={props?.errorData?.isOpen}
    //         displayType={ErrorDisplayType.INSECTION}
    //       />
    //     </Card.Body>
    //   )}
    //   {!props?.errorData?.isOpen && (
    //     <Card.Body
    //       className="p-0 sale-process-body"
    //       // className={"p-0 "+props?.errorData?.isOpen?"tb-border":""}
    //     >
    //       <Table responsive className="sales-table m-0">
    //         <thead className="bg_aqua_white">
    //           <tr>
    //             {props.columnsList &&
    //               props.columnsList.map((column, idx) => {
    //                 return (
    //                   <th key={idx} className="DMSans_16_500 txt_primaryGrey">
    //                     {column.tooltipText ? (
    //                       <GenericTooltip
    //                         placement={"top"}
    //                         toolTipText={column.tooltipText}
    //                         triggerType="hover"
    //                         toolTipClassName="profile-tooltips"
    //                         noButton={true}
    //                         button={column.name}
    //                       />
    //                     ) : (
    //                       column.name
    //                     )}
    //                   </th>
    //                 );
    //               })}
    //           </tr>
    //         </thead>
    //         <tbody>
    //           {props.tbodyData &&
    //             props.tbodyData?.length > 0 &&
    //             props.tbodyData.map((row: any, trId: number) => {
    //               if (row["data"]) {
    //                 return (
    //                   <>
    //                     <tr key={trId}>
    //                       {props.columnsList &&
    //                         props.columnsList.map((column, id) => {
    //                           if (id === 0)
    //                             return (
    //                               <td
    //                                 className="extra-data d-flex align-items-center border-0 hand_cursor"
    //                                 key={id}
    //                                 onClick={() => {
    //                                   let temp = [...showData];
    //                                   temp[trId] = !temp[trId];
    //                                   setShowData(temp);
    //                                 }}
    //                               >
    //                                 {column.tdCustomFunction
    //                                   ? column.tdCustomFunction(
    //                                       row[`${column.key}`],
    //                                       row,
    //                                       column.key,
    //                                       false,
    //                                       trId,
    //                                       props.toggleCheck,
    //                                       row[`${column?.key2}`]
    //                                     )
    //                                   : row[`${column.key}`]}
    //                                 <i
    //                                   className={`${
    //                                     showData[trId]
    //                                       ? "edel-icon-arrow-up"
    //                                       : "edel-icon-arrow-down"
    //                                   } txt-midnight-blue `}
    //                                 ></i>
    //                               </td>
    //                             );
    //                           else {
    //                             return (
    //                               <td key={id}>
    //                                 {column.tdCustomFunction
    //                                   ? column.tdCustomFunction(
    //                                       row[`${column.key}`],
    //                                       row,
    //                                       column.key,
    //                                       false,
    //                                       trId,
    //                                       props.toggleCheck,
    //                                       row[`${column?.key2}`]
    //                                     )
    //                                   : row[`${column.key}`]}
    //                               </td>
    //                             );
    //                           }
    //                         })}
    //                     </tr>
    //                     {showData[trId] &&
    //                       row["data"].map((extraData: any, idx: number) => {
    //                         return (
    //                           <tr key={idx} className="no-border">
    //                             {props.columnsList &&
    //                               props.columnsList.map((column, id) => {
    //                                 return (
    //                                   <td key={id}>
    //                                     {column.tdCustomFunction
    //                                       ? column.tdCustomFunction(
    //                                           extraData[`${column.key}`],
    //                                           row,
    //                                           column.key,
    //                                           true,
    //                                           idx,
    //                                           props.toggleCheck,
    //                                           extraData[`${column?.key2}`]
    //                                         )
    //                                       : extraData[`${column.key}`]}
    //                                   </td>
    //                                 );
    //                               })}
    //                           </tr>
    //                         );
    //                       })}
    //                   </>
    //                 );
    //               }
    //               return (
    //                 <tr key={trId}>
    //                   {props.columnsList &&
    //                     props.columnsList.map((column, id) => {
    //                       return (
    //                         <td key={id}>
    //                           {column.tdCustomFunction
    //                             ? column.tdCustomFunction(
    //                                 row[`${column.key}`],
    //                                 row,
    //                                 column.key,
    //                                 false,
    //                                 trId,
    //                                 props.toggleCheck,
    //                                 row[`${column?.key2}`]
    //                               )
    //                             : row[`${column.key}`]}
    //                         </td>
    //                       );
    //                     })}
    //                 </tr>
    //               );
    //             })}
    //         </tbody>
    //         <tfoot className={props.tfootColored ? "bg_aqua_white" : ""}>
    //           <tr>
    //             <td className="txt-midnight-blue">Total</td>
    //             {props?.showClientCount && <>{props?.totalDataUI()}</>}
    //             {!props?.showClientCount &&
    //               props?.totolData &&
    //               props?.totolData.length > 0 &&
    //               props.totolData.map((record, id) => {
    //                 return (
    //                   <td key={id} className="txt-midnight-blue">
    //                     <ReportValue
    //                       val={props.toggleCheck ? summarize(record) : record}
    //                       stream={false}
    //                       onlyval={false}
    //                       withoutDigit={true}
    //                       showZero={false}
    //                       showSummarize={props.toggleCheck}
    //                     />
    //                   </td>
    //                 );
    //               })}
    //           </tr>
    //         </tfoot>
    //         {/* <tfoot className={props.tfootColored ? "bg_lightBlueOne" : ""}>
    //          {props.tFooterData &&
    //            props.tFooterData.map((row: any, idx: number) => {
    //              return (
    //                <tr key={idx}>
    //                  {props.columnsList &&
    //                    props.columnsList.map((column, id) => {
    //                      return <td key={id}>{row[`${column.key}`]}</td>;
    //                    })}
    //                </tr>
    //              );
    //            })}
    //        </tfoot> */}
    //       </Table>
    //     </Card.Body>
    //   )}
    // </Card>
    );
};
export default SaleProcessTable;
